import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send"; // Importing Send Icon
import Divider from "@mui/material/Divider"; // Importing Divider component
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography"; // Importing Typography for custom styling
import ExportSuccessfulDialog from "./ExportSuccessfulPopup";

// Create a custom theme
const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "14px", // Font size for text
          borderRadius: "8px", // Rounded corners for button
          padding: "8px 16px", // Padding for the button
          textTransform: "none", // Prevent text from being all caps
          boxShadow: "none", // No shadow for the button
        },
        contained: {
          backgroundColor: "#1976d2", // Light blue background for the Confirm button
          color: "#fff", // White text color
          "&:hover": {
            backgroundColor: "#1665c1", // Slightly darker blue on hover
          },
        },
        text: {
          color: "#1976d2", // Light blue color for Cancel button
          padding: "6px 0", // Padding for the hyperlink button
          "&:hover": {
            textDecoration: "none", // Ensure no underline on hover
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "16px", // Rounded corners for the dialog
        },
      },
    },
  },
});

const ConfirmationDialog = ({
  onClick,
  setOpenExportPopUp,
  message,
  setMessage,
  text,
  successMessage,
}) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    setOpenExportPopUp(false);
  };

  const handleConfirm = () => {
    // console.log("Confirmed!");
    setOpen(false);
    if (onClick) {
      onClick();
      // setTimeout(() => {
      //   setOpenExportPopUp(false);
      //   // setOpen(false);
      // }, 2000);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <DialogTitle id="confirmation-dialog-title">
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            Are you sure?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="confirmation-dialog-description"
            style={{ color: "black" }}
          >
            {text}
          </DialogContentText>
          {/* Horizontal Divider */}
          <Divider
            style={{
              margin: "16px 0",
              marginTop: "35px",
              marginBottom: "5px",
              backgroundColor: "#b0b0b0",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="text">
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            color="contained"
            variant="contained"
            // startIcon={<SendIcon />}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {message && (
        <ExportSuccessfulDialog
          setMessage={setMessage}
          setOpenExportPopUp={setOpenExportPopUp}
          successMessage={successMessage}
        />
      )}
    </ThemeProvider>
  );
};

export default ConfirmationDialog;
